
const DragDown = ({
    color = '#000',
    fondo = '#fff',
    vetor_css = { fontSize: '50px' },
    main_css = { width: '40px', padding: '0px' }
}) => {

    return (
        <svg id="drag-bottom-icon" xmlns="http://www.w3.org/2000/svg" style={main_css} viewBox="0 0 9460 5120">
            <g id="l1ZKxGnCVADqN5GAZyVB7Rd" fill={color}>
                <g>
                    <path id="p1CZNOSB97" d="M2537 4040 c-1253 -588 -2297 -1083 -2320 -1099 -212 -147 -274 -455 -136 -672 73 -114 200 -201 334 -229 65 -14 178 -8 235 11 19 7 955 444 2080 972 1125 528 2054 964 2066 969 17 8 347 -150 1980 -952 1077 -529 1983 -971 2013 -982 229 -82 501 32 607 257 96 202 59 412 -100 570 l-71 71 -2195 1077 c-1208 592 -2200 1077 -2205 1077 -6 0 -1035 -482 -2288 -1070z">
                    </path>
                    <path id="ph2X0Ydcc" d="M3510 1760 c-696 -364 -1343 -702 -1438 -752 -140 -74 -184 -102 -231 -149 -69 -70 -116 -157 -136 -254 -18 -87 -18 -113 -1 -197 51 -236 256 -403 497 -401 36 0 88 6 116 12 32 8 526 260 1257 641 l1205 629 1138 -621 c626 -342 1165 -630 1198 -640 82 -27 209 -26 295 1 207 65 350 262 350 481 0 134 -51 252 -149 349 -63 61 -131 100 -1431 809 -751 409 -1374 746 -1385 748 -12 3 -504 -248 -1285 -656z">
                    </path>
                </g>
            </g>
        </svg>

    )
}

export default DragDown;